import { useState } from 'react'
import { Capacitor } from '@capacitor/core'

const DISMISS_KEY = 'bp-ios-install-hint-dismissed'

function shouldShow(): boolean {
  // ネイティブアプリ内では「ホーム画面に追加」の案内は不要
  if (Capacitor.isNativePlatform()) return false
  try {
    if (localStorage.getItem(DISMISS_KEY)) return false
  } catch {
    return false
  }
  const nav = navigator as Navigator & { standalone?: boolean }
  const isIos = /iPhone|iPad/.test(navigator.userAgent)
  // navigator.standalone is defined (false) only in iOS Safari when not installed
  return isIos && nav.standalone === false
}

/** iOS Safariでのみ表示する「ホーム画面に追加」の控えめな案内バナー */
export function IosInstallHint() {
  const [visible, setVisible] = useState(shouldShow)

  if (!visible) return null

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // ignore
    }
    setVisible(false)
  }

  return (
    <div
      role="note"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 12px',
        paddingBottom: 'calc(8px + env(safe-area-inset-bottom))',
        background: 'var(--color-accent-light, #EEF1F7)',
        borderTop: '1px solid var(--color-border-light, #e5e7eb)',
        fontSize: 12,
        color: 'var(--color-text-primary, #111)',
        flexShrink: 0
      }}
    >
      <span style={{ flex: 1, minWidth: 0 }}>
        ホーム画面に追加するとアプリとして使えます: 共有ボタン → ホーム画面に追加
      </span>
      <button
        onClick={dismiss}
        aria-label="閉じる"
        style={{
          background: 'transparent',
          border: 0,
          cursor: 'pointer',
          padding: 4,
          lineHeight: 1,
          fontSize: 14,
          color: 'var(--color-text-secondary, #666)',
          flexShrink: 0
        }}
      >
        ✕
      </button>
    </div>
  )
}
